import React, { useState } from 'react'
import { Grid, IconButton, InputBase, Paper, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined'
import useStyles from './useStyles'
import RestoreModal from '../../../../components/Modals/Storage/RestoreModal'

export const SearchBar = ({
  setLoading,
  setvalueFilter,
  handleGetFilterRecycle,
  elementsChecked,
  getRecycleRequest
}) => {
  const classes = useStyles()

  // Modal restore
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)

  const [searchValue, setsearchValue] = useState('')
  const [buttonSearch, setbuttonSearch] = useState(false)

  // change textflied
  const handlechangeSearch = (event) => {
    setsearchValue(event.target.value)
    event.target.value !== '' ? setbuttonSearch(true) : setbuttonSearch(false)
  }

  // get candidates documents of name filter
  const handleGetDocumentsOfName = async () => {
    setLoading(true)
    setvalueFilter(searchValue)
    await handleGetFilterRecycle('search_value', searchValue)
    setLoading(false)
  }
  // enter search name filter
  const handleSearchSubmit = (event) => {
    if (
      event.type === 'keydown' &&
      event.key === 'Enter' &&
      searchValue !== ''
    ) {
      handleGetDocumentsOfName()
    }
  }

  // restore documents request
  // const handleRestoreDocuments = async () => {
  //   try {
  //     const ids =
  //     console.log(ids)
  //     const response = await restoreInternalRecycleBin(ids)
  //     console.log(response)
  //
  //   } catch (error) {
  //     console.log(error)
  //
  //   }
  // }
  return (
    <Grid container className={classes.gridContainerInputSearch}>
      <Grid item xs={7} className={classes.gridCointanerInputSearch2}>
        <Paper className={classes.input}>
          <InputBase
            sx={{
              ml: 1,
              flex: 1
            }}
            className={classes.inputBase}
            placeholder="Buscar por nombre"
            inputProps={{ 'aria-label': 'search' }}
            value={searchValue}
            onChange={handlechangeSearch}
            onKeyDown={handleSearchSubmit}
          />
          {buttonSearch
            ? (
            <Typography
              onClick={handleGetDocumentsOfName}
              className={classes.buttonSearchInput}
            >
              Buscar
            </Typography>
              )
            : (
            <IconButton type="submit" sx={{ p: '10px' }} aria-label="search">
              <SearchIcon style={{ color: '#028B7E' }} />
            </IconButton>
              )}
        </Paper>
      </Grid>
      <Grid item xs={5} className={classes.gridMenuType}>
        {elementsChecked && elementsChecked.length > 0 && (
          <div className={classes.boxRestoreOption} onClick={handleOpen}>
            <RestoreOutlinedIcon style={{ fontSize: '1.3em' }} />
            <Typography className={classes.typographyOptions}>
              Restaurar documento{elementsChecked.length > 1 && 's'}
            </Typography>
          </div>
        )}
        <RestoreModal
          open={open}
          setOpen={setOpen}
          ids={elementsChecked.map((element) => element.documentId)}
          getRecycleRequest={getRecycleRequest}
          setLoading={setLoading}
        />
      </Grid>
    </Grid>
  )
}
